export const getInstallationName = () =>
  window.globalConfig?.INSTALLATION_NAME ||
  window.globalConfig?.installationName;

const trimTrailingSlash = url => url?.replace(/\/$/, '');

const getHostName = url => {
  if (!url) return '';

  try {
    return new URL(url).host;
  } catch {
    return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }
};

export const replaceInstallationName = text => {
  if (!text || typeof text !== 'string') return text;

  const installationName = getInstallationName();
  const brandURL = trimTrailingSlash(
    window.globalConfig?.BRAND_URL || window.globalConfig?.brandURL
  );
  const hostURL = trimTrailingSlash(window.chatwootConfig?.hostURL);
  const helpCenterURL = trimTrailingSlash(window.chatwootConfig?.helpCenterURL);
  const appHost = getHostName(hostURL || brandURL);
  const helpCenterHost = getHostName(helpCenterURL || hostURL || brandURL);

  let brandedText = text;

  if (brandURL) {
    brandedText = brandedText.replace(
      /https:\/\/eloja360\.digital/g,
      brandURL
    );
  }

  if (appHost) {
    brandedText = brandedText.replace(/eatende\.eloja360\.digital/g, appHost);
  }

  if (helpCenterHost) {
    brandedText = brandedText.replace(
      /eatende\.eloja360\.digital/g,
      helpCenterHost
    );
  }

  if (!installationName) return brandedText;

  return brandedText.replace(/eAtende360/g, installationName);
};
